module.exports = __webpack_public_path__ + "static/media/v6m.10e9d7ac.mp4";